export default "__VITE_ASSET__BEQ7RAOF__"